import { useState } from "react";
import axios from "axios";
import "./Guestbook.css";
import { addMessage } from "./addMessage";
import { deleteUser } from "./deleteUser";
import { makeCSRFRequest } from "../../utils/csrf";
import { BASE_URL } from "../../App";

export default function GuestbookForm(props) {
  const [post, setPost] = useState("");
  const [userIpAddress, setUserIpAddress] = useState("");
  const [tempName, setTempName] = useState(props.nickname);
  const [modifyUser, setModifyUser] = useState(false);

  const getIpAddress = async () => {
    try {
      const result = await axios.get("https://geolocation-db.com/json/");
      setUserIpAddress(result.data.IPv4);
    } catch (error) {
      console.error(error);
    }
  };

  const addUser = async (nickname, ipAddress) => {
    try {
      const response = await makeCSRFRequest(`${BASE_URL}/vieraskirja/user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          nimi: nickname,
          ip_osoite: ipAddress,
          ihminen: true,
        }),
      });
      if (!response.ok) {
        throw new Error("Käyttäjän luominen epäonnistui");
      }
      const data = await response.json();
      props.setUserId(data.nimi_id);
      props.setNickname(nickname);
      props.saveUserId(data.nimi_id);
      props.saveUserName(nickname);
      props.saveUserToken(data.token);
      return data.nimi_id;
    } catch (error) {
      console.error(error);
    }
  };

  const handleDeleteUser = async () => {
    const confirmation = window.confirm("Haluatko varmasti poistaa käyttäjän?");
    if (confirmation) {
      try {
        await deleteUser(props.userId);
        props.setUserId(null);
        props.setNickname("");
        setTempName("");
        localStorage.removeItem("minebikers_userId");
        localStorage.removeItem("minebikers_nickname");
        await props.refreshPosts();
      } catch (error) {
        console.error("Error deleting user:", error);
        alert("Käyttäjän poisto epäonnistui");
      }
    }
  };

  const handleUpdateUser = async (event) => {
    event.preventDefault();
    setModifyUser(true);
  };

  const handleSaveUpdatedUser = async (event) => {
    event.preventDefault();
    if (tempName.trim().length < 1) {
      alert("Liian lyhyt nimimerkki");
      return;
    }
    if (tempName.trim() === props.nickname.trim()) {
      alert("Ei muutoksia");
      return;
    }
    const token = localStorage.getItem("minebikers_token");

    if (!token || !props.userId) {
      console.log("Token puuttuu");
      return false;
    }
    try {
      const response = await makeCSRFRequest(
        `${BASE_URL}/vieraskirja/user/${props.userId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ nimi: tempName }),
        },
      );
      if (response.ok) {
        const updatedUser = await response.json();
        props.setNickname(updatedUser.nimi);
        setTempName(updatedUser.nimi);
        props.saveUserName(updatedUser.nimi);
        setModifyUser(false);
        props.refreshPosts();
      } else {
        const errorData = await response.json();
        switch (response.status) {
          case 400:
            alert(errorData.error || "Käyttäjänimi on jo käytössä!");
            break;
          case 403:
            alert("Ei oikeutta muuttaa nimeä");
            setModifyUser(false);
            break;
          case 404:
            alert(errorData.error || "Tarvittavia tietoja puuttuu");
            setModifyUser(false);
            break;
          default:
            alert("Käyttäjänimen päivitys epäonnistui!");
        }
      }
    } catch (error) {
      console.error(error);
      alert("Käyttäjänimen päivitys epäonnistui!");
    }
  };

  const handleNameChange = (event) => {
    setTempName(event.target.value);
  };

  const handleMessageChange = (event) => {
    setPost(event.target.value);
  };

  const handleMessageSubmit = async (event) => {
    event.preventDefault();
    const name = tempName || props.nickname;

    if (name.length > 0 && post.length > 0) {
      try {
        const userIp = userIpAddress || (await getIpAddress());
        const userId = await addUser(name, userIp);
        const token = localStorage.getItem("minebikers_token");

        if (userId) {
          await addMessage(userId, token, post, props.linkitys);
          setPost("");
          await props.refreshPosts();
          if (props.linkitys) {
            await props.refreshParent(props.linkitys);
            await props.refreshComments(props.linkitys);
          }
          if (props.onCommentSubmit) {
            props.onCommentSubmit();
          }
        } else {
          alert("Nimimerkki on jo käytössä");
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      console.log("nimi", name);
      alert("Nimimerkin pituus tai viesti on liian lyhyt");
    }
  };

  return (
    <form className="guestbook" style={{ backgroundColor: "black" }}>
      {props.userId && props.nickname ? (
        <div>
          {modifyUser ? (
            <div>
              <input
                type="text"
                defaultValue={props.nickname}
                onChange={handleNameChange}
                style={{
                  height: "150%",
                  fontSize: "150%",
                  textAlign: "center",
                }}
              />
              <button onClick={handleSaveUpdatedUser}>Tallenna</button>
              <button type="button" onClick={() => setModifyUser(false)}>
                Peruuta
              </button>
            </div>
          ) : (
            <>
              <h1
                style={{
                  color: props.isHuman ? "blue" : "red",
                  fontSize: "300%",
                }}
              >
                {props.nickname}
              </h1>
              {!props.isHuman && (
                <p
                  style={{ color: "red", fontWeight: "bold", fontSize: "300%" }}
                >
                  OLET ARESTISSA!
                </p>
              )}
            </>
          )}
          {props.isHuman ? (
            <div>
              <button onClick={handleDeleteUser}>Poista käyttäjä</button>
              <button onClick={handleUpdateUser}>Muokkaa käyttäjänimeä</button>
            </div>
          ) : (
            ""
          )}
        </div>
      ) : (
        <div className="nimimerkki">
          <input
            type="text"
            defaultValue={tempName}
            placeholder="Nimimerkki"
            onChange={handleNameChange}
            style={{ height: "150%", fontSize: "150%", textAlign: "center" }}
          />
        </div>
      )}
      {props.isHuman ? (
        <div className="tekstikenttä">
          <textarea
            value={post}
            placeholder="Kirjoita viestisi tähän"
            onChange={handleMessageChange}
            rows={10}
            style={{
              fontSize: "150%",
              marginLeft: "-10%",
              marginRight: "-10%",
            }}
          />

          <button
            style={{
              marginLeft: "20%",
              marginRight: "20%",
              marginTop: "2%",
              fontSize: "150%",
            }}
            type="submit"
            onClick={handleMessageSubmit}
          >
            Lähetä
          </button>
        </div>
      ) : (
        ""
      )}
    </form>
  );
}
